import { Modal, Spin } from "antd";
import InputLabel from "../../../../../../base/basicComponents/inputLabel";
import NormalSelect from "../../../../../../base/basicComponents/select";
import { NormalTextArea } from "../../../../../../base/basicComponents/input";
import BaseComponent from "../../../../../../base/common/BaseComponent";
import TopFilterBase from "../../../../../commonComponents/listBase/TopFilterBase";
import toDoListService from "../../../../../../service/toDoListService";
import {
  PostDelegateToMessage,
  useBatchDelegate,
} from "app/pages/procedureList/procedureListSections/searchAndColumnSelect/batchDelegateButton";
import { debounce } from "lodash-es";
import { reloadMessage } from "utils/index";

const { sortList, handleFilterOption } = TopFilterBase();
export default class DelegationModal extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      delegateOptionList: [],
      initDelegateSelectValue: this.props.delegatedTo,
      delegateSelectValue: this.props.delegatedTo,
      loading: false,
      modalLoading: false,
      open: false,
      reasonText: null,
      isShowEditModal: true,
      isShowMsgContent: false,
      msgContent: "",
      okText: "Confirm",
      cancelText: "Cancel",
      actionType: "edit",
      reasonTextStatus: "",
      postMessageState: {
        isShowPostSubmitMessage: false,
        failItems: [],
        delegateToName: "",
      },
    };
    // @ts-ignore
    this.user = this.appSetting.localStorageValue.user.get();
    // @ts-ignore
    this.delegatedReason = null;
    // @ts-ignore
    this.delegateToUserId = null;
  }

  /**
   * reset state
   */
  handleSetInitState = debounce(() => {
    this.setState({
      initDelegateSelectValue: this.props.delegatedTo,
      delegateSelectValue: this.props.delegatedTo,
      reasonText: null,
      isShowEditModal: true,
      isShowMsgContent: false,
      msgContent: "",
      okText: "Confirm",
      cancelText: "Cancel",
      actionType: "edit",
      reasonTextStatus: "",
      postMessageState: {
        isShowPostSubmitMessage: false,
        failItems: [],
        delegateToName: "",
      },
    });
    // @ts-ignore
    this.prevState = {};
  }, 100);

  /**
   * when close modal reset state
   * @param {object} prevProps
   * @param {object} prevState
   */
  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      (prevProps.isModalOpen !== this.props.isModalOpen && this.props.isModalOpen === false) ||
      prevProps.delegatedTo !== this.props.delegatedTo
    ) {
      this.handleSetInitState();
    }
    if (prevProps.pmpExcluded !== this.props.pmpExcluded) {
      this.setState({
        initExcludedSelectValue: this.props.pmpExcluded,
        excludedSelectValue: this.props.pmpExcluded,
      });
    }
  }

  /**
   * function about change delegated to select
   * @param {string} value select value
   */
  handleDelegatedChange = (value: any) => {
    this.setState({ delegateSelectValue: value, open: false });
    // @ts-ignore
    this.delegateToUserId = value;
  };

  /**
   * function about change reason textarea value
   * @param {string} value - write value
   */
  handleReasonTextChange = (value: any) => {
    this.setState({ reasonText: value, reasonTextStatus: "" });
    // @ts-ignore
    this.delegatedReason = value;
  };

  /**
   * function about click confirm button in submit confirm modal
   */
  handleSubmitModalConfirm = async () => {
    if (this.state.modalLoading) return;
    this.setState({ modalLoading: true });
    const { delegateSelectValue, reasonText } = this.state;
    const targetItem = this.props.dataList.find(
      (item: any) => item.procedureStepId === this.props.procedureStepId
    );
    if (!targetItem) return;

    const response = await toDoListService
      .multipleDelegate({
        currentNodeAccountId: targetItem.currentNodeAccountId,
        procedureStepIDs: [this.props.procedureStepId],
        delegateTo: delegateSelectValue,
        // @ts-ignore
        delegatedBy: this.user.identityUserInfo.englishName,
        reason: reasonText,
      })
      .catch((error) => {
        // @ts-ignore
        this.delegatedReason = null;
        console.log(error);
        this._alertError("Submit Failed");
      })
      .finally(() => {
        this.setState({ modalLoading: false });
      });

    // @ts-ignore
    const {
      result,
      isLoginUserNoPermission,
      isDelegateeNoPermission,
      delegateTo,
      isHaveSuccessful,
      failureDelegateVOs,
    } = response;
    if (isLoginUserNoPermission) {
      reloadMessage({ type: "error", message: "You don't have permission to handle the to-do." });
      window.location.reload();
      return;
    }
    if (isDelegateeNoPermission) {
      this._alertError(
        `${delegateTo} no longer has permission to handle the to-do. Please delegate the to-do to another person.`,
        5
      );
      // @ts-ignore
      this.setState({ ...this.prevState, delegateSelectValue: "" });
      return;
    }
    if (!result) {
      this._alertError(
        "You can not delegate this to-do to process initiator, the upstream approvers and someone that already have this to-do.",
        5
      );
      // @ts-ignore
      this.setState({ ...this.prevState, delegateSelectValue: "" });
      return;
    }
    if (result && failureDelegateVOs.length > 0) {
      this.setState({
        msgContent: "",
        postMessageState: {
          isShowPostSubmitMessage: true,
          failItems: failureDelegateVOs,
          delegateToName: delegateTo,
        },
      });
      return;
    }
    if (isHaveSuccessful) {
      // @ts-ignore
      this.delegatedReason = null;

      this.setState({
        delegateSelectValue: delegateTo,
        initDelegateSelectValue: delegateTo,
      });
      this.handleCancelModalConfirm();
      this._alertSuccess("Submit Successful");
      useBatchDelegate.getState().setFlushTable();
    }
  };

  /**
   * function about click cancel button in submit confirm modal
   */
  handleSubmitModalCancel = () => {
    // @ts-ignore
    this.setState({ ...this.prevState });
  };

  /**
   * function about create submit modal
   */
  handleSetSubmitModal = () => {
    // @ts-ignore
    this.prevState = { ...this.state };
    this.setState({
      msgContent: <span className="fs-16">Are you sure to submit?</span>,
      okText: "Confirm",
      actionType: "submit",
      isShowEditModal: false,
      isShowMsgContent: true,
    });
  };

  /**
   * function about click confirm button in cancel modal
   */
  handleCancelModalConfirm = () => {
    this.props.handleCloseModal();
    this.setState({
      msgContent: "",
      okText: "Confirm",
      actionType: "edit",
      isShowEditModal: true,
      isShowMsgContent: false,
    });
  };

  /**
   * function about click cancel button in cancel modal
   */
  handleCancelModalCancel = () => {
    this.setState({
      // @ts-ignore
      ...this.prevState,
    });
  };

  /**
   * function about create cancel modal
   */
  handleSetCancelModal = () => {
    this.setState({
      msgContent: <span className="fs-16">Are you sure to quit without saving?</span>,
      okText: "Confirm",
      actionType: "cancel",
      isShowEditModal: false,
      isShowMsgContent: true,
    });
  };

  /**
   * function about click confirm button in delegate modal
   */
  handleEditSubmitConfirm = () => {
    if (
      this.props.processCategory === "Update Procedure" &&
      this.props.highlyRegulated === "Yes" &&
      this.props.actionRequired === "Approve"
    ) {
      if (this.state.reasonText === null || this.state.reasonText === "") {
        this.setState({ reasonTextStatus: "error" });
      } else {
        this.handleSetSubmitModal();
      }
    } else {
      this.handleSetSubmitModal();
    }
  };

  /**
   * function about click cancel button in edit modal
   */
  handleEditModalCancel = () => {
    // @ts-ignore
    this.prevState = { ...this.state };
    this.setState({
      msgContent: <span className="fs-16">Are you sure to quit without saving?</span>,
      okText: "Confirm",
      actionType: "cancel",
      isShowEditModal: false,
      isShowMsgContent: true,
    });
  };

  /**
   * function about return submit method for modal component
   * @returns
   */
  handleSubmit = () => {
    switch (this.state.actionType) {
      case "edit":
        return this.handleEditSubmitConfirm();
      case "submit":
        return this.handleSubmitModalConfirm();
      case "cancel":
        return this.handleCancelModalConfirm();
      default:
        return;
    }
  };

  /**
   * function about return cancel method for modal component
   * @returns
   */
  handleCancel = () => {
    switch (this.state.actionType) {
      case "edit":
        return this.handleEditModalCancel();
      case "submit":
        return this.handleSubmitModalCancel();
      case "cancel":
        return this.handleCancelModalCancel();
      default:
        // @ts-ignore
        return this.handleCancelClick();
    }
  };

  /**
   * function about get ppo option list for delegated to
   */
  getPpoOptionsList = async () => {
    const result = await toDoListService
      .getMultipleDelegateToList({
        procedureStepIDs: [this.props.procedureStepId],
      })
      .catch((error) => {
        console.log(error);
        this._alertError("Get Delegated To List Failed");
      });

    const list = result;
    // @ts-ignore
    const newList = list.map((item: any) => {
      return {
        name: item.name,
        value: item.id,
      };
    });

    const isDelegatedToExist = newList.find((item: any) => item.value === this.props.delegatedToId);
    const oldDelegatedTo = isDelegatedToExist ? this.props.delegatedToId : this.props.delegatedTo;

    const isPropsDelegatedToNoValue =
      this.props.delegatedToId === null || this.props.delegatedToId.trim === "";
    const currentDelegatedTo =
      isPropsDelegatedToNoValue || this.state.delegateSelectValue !== this.props.delegatedTo
        ? this.state.delegateSelectValue
        : oldDelegatedTo;
    // const currentInitDelegatedTo = isPropsDelegatedToNoValue ? this.props.delegatedTo : this.props.delegatedToId;
    this.setState({
      delegateOptionList: newList.sort((s: any, t: any) => sortList(s, t)),
      delegateSelectValue: currentDelegatedTo,
      // initDelegateSelectValue: currentInitDelegatedTo,
      loading: false,
      open: true,
    });
  };

  render() {
    const { isModalOpen } = this.props;
    const {
      initDelegateSelectValue,
      delegateSelectValue,
      reasonText,
      reasonTextStatus,
      isShowEditModal,
      okText,
      cancelText,
      actionType,
      loading,
      modalLoading,
      delegateOptionList,
      isShowMsgContent,
      msgContent,
      open,
      postMessageState: { isShowPostSubmitMessage, failItems, delegateToName },
    } = this.state;
    const isReasonRequired =
      this.props.processCategory === "Update Procedure" &&
      this.props.highlyRegulated === "Yes" &&
      this.props.actionRequired === "Approve";
    return (
      <Modal
        open={isModalOpen}
        okText={okText}
        cancelText={cancelText}
        onOk={this.handleSubmit}
        onCancel={this.handleCancel}
        closable={false}
        maskClosable={false}
        okButtonProps={{
          disabled:
            actionType === "edit" &&
            (delegateSelectValue === initDelegateSelectValue || !delegateSelectValue),
          "data-testid": "delegation-confirm-btn",
        }}
        cancelButtonProps={{ "data-testid": "delegation-cancel-btn" }}
        wrapClassName="pmpExcludedModal"
        zIndex={1201}
        {...(isShowPostSubmitMessage && {
          bodyStyle: { padding: "16px", paddingBottom: "10px" },
          footer: null,
          width: 768,
        })}
      >
        <Spin spinning={modalLoading}>
          {isShowEditModal && (
            <div className="delegateContainer">
              <div className="delegatePart">
                <InputLabel text="Delegate To" className="delegateLabel" required={true} />
                <NormalSelect
                  showSearch={true}
                  optionList={delegateOptionList}
                  handleFilterOption={(input: any, option: any) =>
                    handleFilterOption(input, option)
                  }
                  handleChange={this.handleDelegatedChange}
                  value={delegateSelectValue}
                  loading={loading}
                  testid="delegation-delegate-to-select"
                  onDropdownVisibleChange={(open: any) => {
                    if (open) {
                      this.setState({ loading: true });
                      this.getPpoOptionsList();
                    } else {
                      this.setState({
                        open: false,
                      });
                    }
                  }}
                  open={open}
                />
              </div>
              <div className="delegateReasonPart">
                <div className="delegateReasonInput">
                  <InputLabel text="Reason" className="delegateLabel" required={isReasonRequired} />

                  <NormalTextArea
                    width="22.2"
                    value={reasonText}
                    onChange={(e: any) => this.handleReasonTextChange(e.target.value)}
                    status={reasonTextStatus}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    className="delegateReasonText scrollExpendDiv"
                    testid="delegation-reason-textarea"
                  />
                </div>
              </div>
            </div>
          )}
          {isShowMsgContent && msgContent}
          {isShowPostSubmitMessage && (
            <PostDelegateToMessage
              messageState={{ failItems, successFlag: false }}
              closeModal={this.handleCancelModalConfirm}
              delegateToName={delegateToName}
            />
          )}
        </Spin>
      </Modal>
    );
  }
}
